export default __webpack_public_path__ + "static/AE-a1c38279b9a32e012378661034741d8f.png";